import { render } from "./ChatWindowView.vue?vue&type=template&id=17dbca85&scoped=true"
import script from "./ChatWindowView.vue?vue&type=script&lang=js"
export * from "./ChatWindowView.vue?vue&type=script&lang=js"

import "./ChatWindowView.vue?vue&type=style&index=0&id=17dbca85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dbca85"]])

export default __exports__